$(window).scroll(function () {
  var scroll = $(window).scrollTop();
  var richtxt_height = $(".richtxt_wrap .page-width").height();
  if (scroll >= 100) {
    $(".richtxt_wrap").removeClass("rich_animation");
    $(".richtxt_wrap").css("height", richtxt_height + 60);
  }
});

// var trending_arr = [];
// const $article_grid = $('.trending-article-div');
// const blog_handle = $article_grid.attr('data-blog');
// var current_page = 1;
// async function getTrendingArticles(blog,page=1){
//   const response = await fetch('/blogs/'+blog+'/tagged/trending-article?view=ajax&page='+1);
//   const data = await response.text();
//   var htmlData = $(data);
//   if(htmlData){
//       $.each(htmlData,function(index,ele) {
//         trending_arr.push(ele)
//       })
//   }
//           var trending_blocks = htmlData;
//           if(trending_arr.length<3){
//             console.log('calling page ',1)
//             getTrendingArticles(1);
//           }

//   if(trending_arr.length>0 && trending_arr.length<3){
//     console.log('calling page ',1)
//     await getTrendingArticles(blog_handle,1);
//   }
//   // console.log(trending_arr.length)
//   return trending_arr;
// }

$(document).ready(function () {
  function kFormatter(num) {
    return Math.abs(num) > 999
      ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
      : Math.sign(num) * Math.abs(num);
  }

  function initCustomSubscription() {
    $("body").on("click", ".js-subscription-option", function (e) {
      e.preventDefault();
      var parent = $(this),
        selected_opt = parent.attr("data-type");
      $(".rc_widget__option__input").removeAttr("checked");
      $(".js-subscription-option").removeClass("is-active");
      parent.addClass("is-active");
      //     console.log(selected_opt,$('.rc_widget__option__input[value="'+selected_opt+'"]'))
      $(
        '.rc_widget__option__input[value="' +
          selected_opt +
          '"],input[name="purchaseOption"][value="' +
          selected_opt +
          '"]'
      )
        .trigger("click")
        .attr("checked", "checked")
        .prop("checked", true);
    });
    $("body").on("change", "#rc_shipping_interval_frequency", function () {
      var $this_val = $(this).children("option:selected").val();
      $("select[name='selling_plan']").val($this_val).trigger("change");
    });
    $("body").on("change", ".subs-ui__select", function () {
      var curr_opt = $(".subs-ui__select option:selected");
      $(".subs-ui__item-dropdown-selected-text").text(curr_opt.text());
    });
  }

  //write your code below this line

  const YOTPO_API_KEY = "LBpm6ujQSjJ1n9FuZzAcl7xhE8UInaYJe8423cgD";
  const _reviews_per_page = 20;
  const _reviews_page = 1;
  let _reviews_count = 0;

  theme.display_reviews = (
    review_wrapper,
    review_statics,
    reviews,
    review_stats,
    review_html_string
  ) => {
    let $review_wrapper = $(review_wrapper),
      $review_stats_wrapper = $(review_statics);
    $review_wrapper.empty();
    $review_stats_wrapper.empty();
    const review_statistics = `${review_stats.average_score.toFixed(
      1
    )}/5 (${kFormatter(review_stats.total_review)} Reviews)`;
    $review_stats_wrapper.html(review_statistics);
    if (reviews.length == 0) {
      let cur_review = review_html_string
        .replaceAll("{review_body}", "No Reviews found")
        .replaceAll("{review_title}", "")
        .replaceAll("{review_customer_name}", "");
      $review_wrapper.append($(cur_review));
      $review_wrapper.parents(".featured-product-review").hide();
    } else {
      $review_wrapper.parents(".featured-product-review").show();
    }
    for (var i = 0; i < reviews.length; i++) {
      var single_review = reviews[i];
      let cur_review = review_html_string
        .replaceAll("{review_body}", single_review.content)
        .replaceAll("{review_title}", single_review.title)
        .replaceAll(
          "{review_initial}",
          single_review.user.display_name.toUpperCase().substring(0, 1)
        )
        .replaceAll("{review_customer_name}", single_review.user.display_name);
      $review_wrapper.append($(cur_review));
    }
  };
  theme.get_reviews = (featured_reviews = false) => {
    const review_html_string = `<div class="reviewSlider_product"> <div class="yotpo-review-stars "> <span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span> <span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span> <span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span> <span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span> <span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span> </div><div class="review-title">{review_title}</div><div class="reviewSlider-comments">“{review_body}”</div><div class="reviewSlider_name_wrapper"> <span class="yotpo-user-letter">{review_initial}</span> <div class="reviewSlider_name"> <p class="profile-name">{review_customer_name}</p></div></div></div>`;
    if ($(".featured-product-review").length) {
      //     console.log('//api.yotpo.com/v1/widget/' + YOTPO_API_KEY + '/products/' + theme.product_json.id + '/reviews.json')
      var url =
        "//api.yotpo.com/v1/widget/" +
        YOTPO_API_KEY +
        "/products/" +
        window.theme.product_json.id +
        "/reviews.json?sort=date&direction=desc";
      if (featured_reviews) {
        url =
          "//api.yotpo.com/v1/widget/" +
          YOTPO_API_KEY +
          "/products/" +
          window.theme.product_json.id +
          "/reviews.json?sort=date&direction=desc";
      }
      console.log(url);
      $.get(
        url,
        {
          per_page: featured_reviews ? 10 : 30,
          page: _reviews_page,
        },
        function (data) {
          _reviews_count = data.response.bottomline.total_review;
          //         console.log(data.response)
          const wrapper =
            ".featured-product-review [data-yotpo-review-wrapper]";
          const review_statistics0 =
            ".featured-product-review [data-yotpo-review-statistics]";
          if (data.status.code == 200) {
            if (data.response.reviews.length) {
              var allReviews = data.response.reviews;
              var fiveStarReview = $.grep(
                data.response.reviews,
                function (item) {
                  return item.score == 5;
                }
              );
              var finalReviewArr = [];
              finalReviewArr.push(fiveStarReview[0]);
              var restReviews = $.grep(allReviews, function (item) {
                return item.id != fiveStarReview[0].id;
              });
              restReviews.unshift(fiveStarReview[0]);
              const top_3_reviews = restReviews.slice(0, 3);
              const review_stats = data.response.bottomline;
              theme.display_reviews(
                wrapper,
                review_statistics0,
                top_3_reviews,
                review_stats,
                review_html_string
              );
            } else {
              theme.display_reviews(
                wrapper,
                review_statistics0,
                top_3_reviews,
                review_stats,
                review_html_string
              );
            }
          } else {
            console.log("error loading yotpo");
            return !1;
          }
        }
      );
    }
  };

  theme.display_featured_reviews = (
    review_limit,
    review_wrapper,
    review_statics,
    reviews,
    review_stats,
    review_html_string
  ) => {
    let $review_wrapper = $(review_wrapper),
      $review_stats_wrapper = $(review_statics);
    $review_wrapper.empty();
    $review_stats_wrapper.empty();
    // const review_statistics = `${review_stats.average_score.toFixed(1)}/5 (${kFormatter(review_stats.total_review)} Reviews)`;
    // $review_stats_wrapper.html(review_statistics);
    if (reviews.length == 0) {
      let cur_review = review_html_string
        .replaceAll("{review_body}", "No Reviews found")
        .replaceAll("{review_title}", "")
        .replaceAll("{review_customer_name}", "");
      $review_wrapper.append($(cur_review));
      $review_wrapper.parents(".featured-product-review").hide();
    } else {
      $review_wrapper.parents(".featured-product-review").show();
    }
    for (var i = 0; i < review_limit; i++) {
      var single_review = reviews[i];
      let cur_review = review_html_string
        .replaceAll("{review_body}", single_review.content)
        .replaceAll("{review_title}", single_review.title)
        .replaceAll(
          "{review_initial}",
          single_review.user.display_name.toUpperCase().substring(0, 1)
        )
        .replaceAll("{review_customer_name}", single_review.user.display_name);
      $review_wrapper.append($(cur_review));
    }
  };
  theme.featured_reviews = function () {
    if ($(".featured-testimonials-yotpo").length) {
      var limit = $(".featured-testimonials-yotpo")
        .find(".testimonials-section")
        .data("limit");
      var eles = $(".featured-testimonials-yotpo");
      const review_html_string = `<div class="reviewSlider_product">
       <div class="reviewSlider_product_wrap">
    <div class="yotpo-review-stars ">
   <span class="testimonial-stars">★★★★★</span>
    </div>
    <div class="review-title">{review_title}</div>
    <div class="reviewSlider-comments addReadMore showlesscontent" data-limit-chars="260" data-mobile-limit="150"
              data-inline-scroll="true">“{review_body}”</div>
    <div class="reviewSlider_name_wrapper">
    <img src="https://cdn.shopify.com/s/files/1/2979/0124/files/Favicon_EUFORA.png?v=1668798629" /> 
    <div class="reviewSlider_name"> <p class="profile-name">{review_customer_name}</p></div>
    </div>
    </div></div>`;
      $.each(eles, function (inx, ele) {
        const total_review = ".total-review";
        const total_review_count = ".total-review-stars .star-count";
        const review_wrapper =
          ".featured-testimonials-yotpo [data-yotpo-review-wrapper]";
        const review_statistics =
          ".featured-testimonials-yotpo [data-yotpo-review-statistics]";
        var wrapper = $(ele);
        const options = {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
        var collectionIdsString = $(".testimonials-section").data("review-id");
        var block_count = $(".testimonials-section").data("block-count");
        var review_limit = $(".testimonials-section").data("review-limit");
        var url =
          "https://api-cdn.yotpo.com/v1/widget/LBpm6ujQSjJ1n9FuZzAcl7xhE8UInaYJe8423cgD/products/";

        var promises;
        if (block_count > 1) {
          var block_review_ids = collectionIdsString
            .split(",")
            .map(function (value) {
              return value.trim();
            });
          promises = block_review_ids.map(function (block_review_id) {
            var blockUrl = url + block_review_id + "/reviews.json?per_page=100";
            return fetch(blockUrl, options).then((response) => response.json());
          });
        } else {
          promises = [
            fetch(
              url + collectionIdsString + "/reviews.json?per_page=100",
              options
            ).then((response) => response.json()),
          ];
        }

        Promise.all(promises)
          .then((results) => {
            var allReviews = [];
            var all_FiveReviews = [];
            var review_stats;
            var limit = Math.ceil(review_limit / block_count);
            results.forEach((result) => {
              if (result.response.reviews.length) {
                for (var i = 0; i < limit; i++) {
                  allReviews = allReviews.concat(result.response.reviews);
                  var fiveStarReviews = result.response.reviews.filter(
                    (item) => item.score === 5
                  );
                  if (fiveStarReviews.length) {
                    all_FiveReviews.push(fiveStarReviews[i]);
                  }
                }
              }
            });

            if (all_FiveReviews.length < review_limit) {
              results.forEach((result) => {
                var remainingReviewsNeeded =
                  review_limit - all_FiveReviews.length;
                for (
                  var j = 0;
                  j < results.length && remainingReviewsNeeded > 0;
                  j++
                ) {
                  var remainingReviews = results[j].response.reviews.filter(
                    (item) =>
                      item.score === 5 && !all_FiveReviews.includes(item)
                  );
                  for (
                    var k = 0;
                    k <
                    Math.min(remainingReviewsNeeded, remainingReviews.length);
                    k++
                  ) {
                    all_FiveReviews.push(remainingReviews[k]);
                    remainingReviewsNeeded--;
                  }
                }
              });
            }

            if (allReviews.length) {
              review_stats = results[0].response.bottomline;
              theme.display_featured_reviews(
                review_limit,
                review_wrapper,
                review_statistics,
                all_FiveReviews,
                review_stats,
                review_html_string
              );
            } else {
              theme.display_featured_reviews(
                review_wrapper,
                review_statistics,
                all_FiveReviews,
                review_stats,
                review_html_string
              );
            }
          })
          .catch((err) => console.error(err))
          .finally(function () {
            theme.sections.register(
              "featured-testimonials-yotpo",
              theme.TestimonialsYotpo
            );
            theme.utils.AddReadMore();
          });
      });
    }
  };

  function manageUpsellSection() {
    var selector = ".js-upsell-wrapper .upsale-product-section";
    if ($(selector).length > 0) {
      if ($(window).width() < 798) {
        if ($(".mobile-upsell-slider .grid-item").length > 3) {
          if (!$(".mobile-upsell-slider").hasClass("flickity-enabled"))
            theme.utils.featuredCollectionSlider(".mobile-upsell-slider");
        }
      }
    } else {
    }
  }

  manageUpsellSection();
  theme.get_reviews();
  $(".js-mobile-variant-selector").on("change", function () {
    var current_opt = $(".js-mobile-variant-selector option:selected"),
      var_id = $(this).val();
    var variant_btn = $(`.variant-input[data-variant-id=${var_id}]`).find(
      "label"
    );
    if (variant_btn.length > 0) {
      variant_btn.trigger("click");
      //       console.log(variant_btn)
    }
  });
  window.on("resize", function () {
    manageUpsellSection();
  });

  function logo_auto_slide() {
    var interval_time =
      (Number($(".logo-rows-wrapper").attr("data-interval_time")) || 2) *
      1000;
    if ($(".logo-rows-wrapper").hasClass("autoHide-false")) {
      return false;
    }
    let names = $(".logo-row");
    var longIntervalTime = interval_time;
    let count = 0;
    function cycleArray() {
      let name = names[count];
      $(".logo-row").css("opacity", "0");
      $(name).css("opacity", "1");

      // increment our counter
      count++;

      // reset counter if we reach end of array
      if (count === names.length) {
        count = 0;
      }
    }
    console.log('interval_time',interval_time)

    setInterval(cycleArray, longIntervalTime);
  }
  logo_auto_slide();

  theme.featured_reviews();

  detectRechargeWidget();
  // if($('.blog').length){
  //   getTrendingArticles(blog_handle,$article_grid.attr('data-current-page')).then((data)=>{
  //   // var counter = 1;
  //       $.each(data,function(index,ele) {
  //         if(index<3){
  //           $article_grid.prepend(ele)
  //         }
  //     })
  // });
  // }
  //write your code above this line
});

function detectRechargeWidget() {
  if (document.querySelector(".product-single__form")) {
    // identify an element to observe
    const elementToObserve = document.querySelector(".product-single__form");
    // create a new instance of `MutationObserver` named `observer`,
    function callback(mutationList) {
      mutationList.forEach(function (mutation) {
        switch (mutation.type) {
          case "attributes":
            switch (mutation.attributeName) {
              case "data-price-mutation-watcher":
                // console.log('rechage widget chagnes');
                formatRechargeMoney();
                break;
            }
            break;
        }
      });
    }
    // passing it a callback function
    const observer = new MutationObserver(callback);
    // call `observe()` on that MutationObserver instance,
    // passing it the element to observe, and the options object
    observer.observe(elementToObserve, {
      subtree: true,
      childList: true,
      attributeOldValue: true,
    });
  }
}
function formatRechargeMoney() {
  var oneTimePrice = document.querySelector("[data-price-onetime]").innerText,
    subsPrice = document.querySelector("[data-price-subsave]").innerText;
  var rechargeFinalPrice = document.querySelector(
    ".recharge-inner-most-price"
  ).innerText;
  var newOnePrice = oneTimePrice;
  if (oneTimePrice.indexOf(".") > -1) {
    var cents = oneTimePrice.split(".")[1];
    newOnePrice = oneTimePrice.split(".")[0] + cents;
    document.querySelector("[data-price-onetime]").innerHTML = newOnePrice;
  }
  if (subsPrice.indexOf(".") > -1) {
    var cents = subsPrice.split(".")[1];
    newOnePrice = subsPrice.split(".")[0] + cents;
    document.querySelector("[data-price-subsave]").innerHTML = newOnePrice;
  }
  if (rechargeFinalPrice.indexOf(".") > -1) {
    var cents = rechargeFinalPrice.split(".")[1];
    newOnePrice = rechargeFinalPrice.split(".")[0] + cents;
    document.querySelector(".recharge-inner-most-price").innerHTML =
      newOnePrice;
  }
}
(function () {
  if (document.readyState === "complete" || document.readyState === "loaded") {
    // console.log('recharge loaded')
    detectRechargeWidget();
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      // console.log('recharge loaded 2')
      detectRechargeWidget();
    });
  }
  detectRechargeWidget();
})();
